module.exports = __webpack_public_path__ + "static/media/ilya-yakover.efe05368.jpg";